import React from 'react';

const VkIcon = ({size = 40}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" fill="white"/>
      <path d="M21.3966 26.4325C13.2821 26.4325 8.6538 21.6034 8.46094 13.5679H12.5256C12.6591 19.4657 15.6556 21.964 18.0291 22.4791V13.5679H21.8565V18.6544C24.2004 18.4355 26.6626 16.1176 27.4933 13.5679H31.3207C30.6828 16.71 28.0126 19.0279 26.1138 19.9808C28.0126 20.7535 31.0538 22.7752 32.2109 26.4325H27.9978C27.0929 23.9857 24.8383 22.0927 21.8565 21.8352V26.4325H21.3966Z" fill="#1536A1"/>
    </svg>
  );
}

export default VkIcon;
